import React, { useState } from "react"
import {
    FormGroup,
    Label,
    Input
} from "reactstrap";
import AuthService from "../services/auth.service";
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

function Login() {
    const [account, setAccount] = useState('')
    const [password, setPassword] = useState('')
    const [showload, setShowload] = useState(false)

    function handleKeyDown(e) {
        if (e.key === 'Enter' && !showload) {
            Login();
        }
    }

    function Login() {
        setShowload(true)
        AuthService.login(account, password)
            .then(response => {
                setShowload(false)
                if (response.success) {
                     const role = response.role;
                     window.location = role === "ADMIN" ? "/dashboard" : "/orders-id";
                    
                } else {
                    Swal.fire({
                        title: 'Thông báo',
                        text: response.message,
                        icon: 'error',
                    })
                }
            }, error => {
                setShowload(false)
                Swal.fire({
                    title: 'Thông báo',
                    text: error,
                    icon: 'error',
                })
            })
    }

    return (
        <div
            style={{
                width: "100%",
                minHeight: "100vh",
                margin: "auto",
                justifyContent: "center",
                alignItems: "center",
                display: "flex"
            }}>



            <div style={{ width: "320px", padding: "1rem" }}>

                <FormGroup>
                    <Label style={{ marginTop: "0.5rem" }} for="account">Tài khoản</Label>
                    <Input
                        style={{ borderRadius: '50px' }}
                        value={account}
                        id="account"
                        onChange={(e) => setAccount(e.target.value)}
                        onKeyDown={handleKeyDown}
                    />
                    <Label style={{ marginTop: "1rem" }} for="password">Mật khẩu</Label>

                    <Input
                        style={{ borderRadius: '50px' }}
                        type="password"
                        value={password}
                        id="password"
                        onChange={(e) => setPassword(e.target.value)}
                        onKeyDown={handleKeyDown}
                    />
                </FormGroup>

                <div style={{ float: "right", marginTop: "0.5rem" }}>
                    <div style={{ width: "100%" }}></div>
                    <button className="btn btn-primary" style={{ borderRadius: '50px' }} onClick={() => Login()}>Đăng nhập {showload ? <span className="spinner-border spinner-border-sm"></span> : null}</button>
                </div>
            </div>
        </div>
    )
}

export default Login